import { renderNecessaryModulesBasedOnUserGeolocation } from 'client/javascript/pages/shared/location_based_override_module';

const VIDEO_CTA_MODULE_SELECTOR = '.video-cta';

export const showVideoCtaModuleByGeolocation = () => {
  renderNecessaryModulesBasedOnUserGeolocation({
    nodes: document.querySelectorAll(VIDEO_CTA_MODULE_SELECTOR),
    showModulesWithoutConditionsToShow: true
  });
};
